import { Box, Heading, Icon, IconSize, ModalBody, Separator, SeparatorType, useModalState } from '@bechtel/gds';
import { map } from 'lodash';
import { FC } from 'react';
import { MultiLingualText } from '~/components/atoms';
import { Message } from '~/hooks';
import { ItemStyled, ModalHeaderStyled, ModalStyled, TextStyled } from '../styled';
import { MessageType } from '../types';
import { BorderStyled, FooterButtonStyled, MessageTypeStyled, ModalFooterStyled } from './styled';

interface ErrorInfoModalProps {
  messages: Message[];
  messageType: MessageType;
  onClose?: () => void;
}

export const ErrorInfoModal: FC<ErrorInfoModalProps> = ({ messages, messageType, onClose }) => {
  const { visible, close } = useModalState(true);

  const handleClose = () => {
    if (onClose) onClose();
    close();
  };

  return (
    <ModalStyled visible={visible}>
      <ModalHeaderStyled title="">
        <Box alignItems={{ sm: 'center' }}>
          <MessageTypeStyled messageType={messageType}>
            <>
              {messageType === MessageType.ERROR && (
                <Icon icon="triangle-exclamation" fillColor="white" iconStyle="solid" size={IconSize.MEDIUM}></Icon>
              )}
              {messageType === MessageType.INFO && (
                <Icon icon="circle-info" fillColor="white" iconStyle="solid" size={IconSize.MEDIUM}></Icon>
              )}
            </>
          </MessageTypeStyled>
          <Box pl={{ sm: '300' }}>
            <Heading size="500" weight="500">
              <MultiLingualText
                textKey={messageType === MessageType.ERROR ? 'WARNING' : 'INFORMATION'}
              ></MultiLingualText>
            </Heading>
          </Box>
        </Box>
      </ModalHeaderStyled>
      {/* @ts-ignore adjust in GDS component to take child as prop  */}
      <ModalBody
        css={`
          flex-direction: column;
        `}
      >
        {messages &&
          messages.length > 0 &&
          map(messages, (langMessage, index) => (
            <Box flexDirection={{ sm: 'column' }} key={index}>
              <ItemStyled flexGrow={{ sm: '1' }}>
                <Separator type={SeparatorType.VERTICAL} color="grey.200" borderWidth="2px"></Separator>
                <TextStyled>{langMessage.messageText}</TextStyled>
              </ItemStyled>
              <BorderStyled />
            </Box>
          ))}
      </ModalBody>
      <ModalFooterStyled>
        <Box p={{ sm: '500' }}>
          <FooterButtonStyled onClick={handleClose} messageType={messageType}>
            <Box px={{ sm: '500' }}>
              <MultiLingualText>OK</MultiLingualText>
            </Box>
          </FooterButtonStyled>
        </Box>
      </ModalFooterStyled>
    </ModalStyled>
  );
};
